import firebase from 'firebase';
import firebaseui from 'firebaseui';

const config = {
  apiKey: 'AIzaSyD__HLf1dxrNPChZJ_OkBgRe62C1RpPbnE',
  authDomain: 'sir-servant.firebaseapp.com',
  databaseURL: 'https://sir-servant.firebaseio.com',
  projectId: 'sir-servant',
  storageBucket: 'sir-servant.appspot.com',
  messagingSenderId: '506540806979',
};

export const uiConfig = {
  signInSuccessUrl: '/#/auth/success',
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
};

export const fireApp = firebase.initializeApp(config);
export const fireUi = new firebaseui.auth.AuthUI(firebase.auth(fireApp));
